export enum DocumentState {
    Quote,
    Proposal,
    Bind,
    Custom
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/infrastructure/model/enum/documentState.enum.ts